module.exports = __webpack_public_path__ + "static/media/user.7aea9cc8.png";